import {action, computed, makeAutoObservable, observable, runInAction} from 'mobx';
import {Availability} from "../model/professional/availability-model";


// ✅ Version alternative avec debugging
export class AvailabilityStore {
    @observable availability: Availability[] | null = null
    @observable isLoading: boolean = false

    constructor() {
        makeAutoObservable(this);
    }

    @action
    setAvailability(availability: Availability[]){
        if (!availability) return;
        this.availability = availability;
        this.isLoading = true;
    }

    @action
    addNewAvailability(availability: Availability[]){
        if (!availability) return;
        this.availability = [...(this.availability || []), ...availability]
    }

    @action
    updateAvailability(availability: Availability) {
        if (!availability || !this.availability) return;
        this.availability = this.availability.map((availab: Availability) => 
            availab.id === availability.id ? availability : availab
        )
    }

    @action
    removeAvailability(id: string) {
        if (!id || !this.availability) return;

        this.availability = this.availability.filter(item => item.id !== id);
    }

    @action
    removeMultipleAvailabilities(ids: string[]) {
        if (!ids || ids.length === 0 || !this.availability) return;
        const idSet = new Set(ids);
        this.availability = this.availability.filter(item => !idSet.has(item.id));
    }

    @action
    updateMultipleAvailabilities(updates: Availability[]) {
        if (!updates || updates.length === 0 || !this.availability) return;
        const updateMap = new Map(updates.map(u => [u.id, u]));
        this.availability = this.availability.map(item => updateMap.get(item.id) || item);
    }

    @computed
    get getAvailability() {
        return this.availability || [];
    }

    @computed
    get getIsLoading() {
        return this.isLoading;
    }
}

const availabilityStore = new AvailabilityStore()
export default availabilityStore